<div class="u-m-bottom--sm">
	<p class="u-text--sm u-m-bottom--tiny ellipsis">
		{{ key }}
		<ng-container *ngIf="info">({{ info }})</ng-container>
	</p>
	<p class="u-text--medium">
		<ng-content></ng-content>
	</p>
</div>
